import { all } from 'redux-saga/effects';
import watchLogin from './sagas/watchLogin';
import watchLogout from './sagas/watchLogout';
import watchFetchUser from './sagas/watchFetchUser';
import watchEditUser from './sagas/watchEditUser';

export default function* watchAll() {
  yield all([watchLogin(), watchLogout(), watchFetchUser(), watchEditUser()]);
}
